<template>
  <div
    class="t-button"
    :class="[inCart ? 'inCart ' + type : type]"
    @click="_callback"
  >
    <span>
      <slot></slot>
    </span>
    <svg class="arrow" width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z"/>
    </svg>
    <svg class="cart" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M15.7299 0.2604C16.0823 0.615296 16.091 1.19969 15.7492 1.56567L6.26776 11.7195C6.10035 11.8988 5.87012 12 5.62963 12C5.38914 12 5.15891 11.8988 4.9915 11.7195L0.250756 6.6426C-0.0909959 6.27661 -0.0823382 5.69222 0.270093 5.33732C0.622525 4.98243 1.18527 4.99142 1.52702 5.3574L5.62963 9.75094L14.473 0.280481C14.8147 -0.0855051 15.3775 -0.0944957 15.7299 0.2604Z"/>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    callback: {
      type: Function,
      default: () => {},
    },
    inCart: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    _callback: function() {
      this.callback();
    },
  },
};
</script>

<style lang="sass" scoped>
@import './src/sass/params.sass'

.t-button
  display: inline-flex
  align-items: center
  padding: 0 40px
  border-radius: 50px
  transition: all .3s, transform .2s
  cursor: pointer
  user-select: none
  span
    margin-right: 16px
    font-family: 'OpenSans regular', sans-serif
    font-size: 16px
    font-weight: 400
    white-space: nowrap

  svg
    opacity: .8
    transition: all .3s

  &.big
    height: 66px
    span
      font-size: 18px

  &.middle
    height: 60px

  &.small
    padding: 0 24px
    height: 52px

  &.white
    border: 2px solid $primary-white-color
    background-color: $primary-white-color
    color: black
    svg
      fill: black

    &:hover
      border: 2px solid $primary-white-color
      color: $primary-white-color
      background-color: transparent
      svg
        fill: $primary-white-color

    &:active
      background-color: rgba(255, 255, 255, 0.35)
      transform: scale(.95)

  &.light
    border: 2px solid $secodary-blue-color
    color: black
    svg
      fill: black

    &:hover
      border: 2px solid #579DE3
      color: $primary-white-color
      background-color: #579DE3
      svg
        fill: $primary-white-color

    &:active
      border: 2px solid #4F8FCE
      background-color: #4F8FCE
      transform: scale(.9)

  &.light-white
    border: 2px solid $primary-white-color
    color: $primary-white-color
    svg
      fill: $primary-white-color

    &:hover
      color: $secodary-blue-color
      background-color: $primary-white-color
      svg
        fill: $secodary-blue-color

  &.blue
    background-color: #5599DD
    color: $primary-white-color
    svg
      fill: $primary-white-color
    &:hover
      background-color: #5DA8F2
    &:active
      background-color: #4F8FCF
      transform: scale(.95)

  &.no-arrow
    span
      margin-right: 0
    .arrow
      display: none

  &.inCart
    .arrow
      display: none
    .cart
      display: block

  &.uppercase
    span
      text-transform: uppercase

  .cart
    display: none

  @media screen and ( max-width: 1919px )
    &.big
      height: 60px

    &.small
      height: 40px
      span
        font-size: 14px

  @media screen and ( max-width: 1279px )
    &.big,
    &.middle,
    &.small
      height: 28px
      padding: 0 18px
      svg
        width: 10px
      span
        font-size: 10px !important
        line-height: 12px
        margin-right: 10px
    &.mobile-size
      height: 28px !important
      span
        font-size: 10px  !important
        line-height: 11px !important
</style>



// WEBPACK FOOTER //
// src/templates/components/ui/button.vue